<template>
  <div class="">
    <section class="bg-n3black text-white relative">
      <div class="container">
        <div class="grid grid-cols-1 lg:grid-cols-2">
          <div class="content-text sm:mb-10 sm:mr-10 mt-10">
            <div class="sm:mt-10 text-justify">
              {{ event.description }}
            </div>

            <template v-if="event && event.restrictions">
              <div class="font-bold pt-[2rem] font-medium mt-10 mb-5">
                Restrictions
              </div>
              <div class="mb-10 restriction">
                <ul class="p-0 m-0">
                  <li
                    v-for="(restriction, index) in event.restrictions"
                    :key="index"
                  >
                    {{ restriction }}
                  </li>
                </ul>
              </div>
            </template>
          </div>
          <div class="mb-10 mt-10 sm:pl-10">
            <div class="pt-5 sm:pt-10 hidden sm:block">
              <div class="text-xl">{{ event.subtitle }}</div>
              <div class="text-[36px] font-medium mb-10">
                {{ event.title }}
              </div>
            </div>

            <div class="mt-5 show-selector">
              <div class="grid grid-cols-2 gap-2">
                <div>
                  <div class="select">
                    <select
                      name="location"
                      id="location"
                      v-model="selectedShow.location"
                    >
                      <option value="">SELECT LOCATION</option>
                      <option
                        :value="location.name"
                        v-for="(location, index) in locations"
                        :key="index"
                      >
                        {{ location.city }}
                      </option>
                    </select>
                  </div>
                </div>

                <div>
                  <div class="select">
                    <select
                      name="dateTime"
                      id="dateTime"
                      @change="handleShowSelection"
                    >
                      <option value="">DATE & TIME</option>
                      <option
                        :value="show.id"
                        v-for="(show, index) in showTimes"
                        :key="index"
                        :selected="selectedShow.show?.id === show.id"
                      >
                        {{
                          dateTimeFormat(
                            show.time.toDate(),
                            "DD.MM.YYYY HH:mm",
                            show.startTimezone
                          )
                        }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="pt-5 mt-5 sm:mt-10">
              <div
                class="grid grid-cols-1 sm:grid-cols-2"
                v-if="selectedShow.show"
              >
                <data-list
                  title="Date"
                  :value="
                    dateTimeFormat(
                      selectedShow.show?.time.toDate(),
                      'DD.MM.YYYY'
                    )
                  "
                />
                <data-list title="Venue" :value="selectedShow.location" />
              </div>

              <div class="mb-5 text-center hidden sm:block">
                <div class="w-3/5 inline-block"></div>
              </div>

              <div class="text-center mt-10">
                <default-button
                  label="Save your tickets now"
                  class="w-full"
                  :disable="!selectedShow.show"
                  @clicked="onGetTickets"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import DataList from "@/components/DataList.vue";
import {
  computed,
  onMounted,
  onUnmounted,
  reactive,
  toRefs,
} from "@vue/runtime-core";
import { useStore } from "vuex";
import { getCurrentInstance } from "vue";
import DefaultButton from "@/components/button/DefaultButton.vue";
import { dateTimeFormat } from "@/utils/helper";
import { useRouter } from "vue-router";
import { useMeta } from "vue-meta";

export default {
  components: { DataList, DefaultButton },
  setup() {
    const store = useStore();
    const { proxy } = getCurrentInstance();

    const router = useRouter();
    const state = reactive({
      FormData: {
        showId: "",
      },
      event: computed(() => store.state.event.event),
      show: computed(() => store.state.show.show),
      selectedShow: computed(() => store.state.show.selectedShow),
      locations: computed(() => store.getters["show/locations"]),
      showTimes: computed(() => store.getters["show/showTimes"]),
      section: computed(() => proxy.$route.query.s || ""),
    });

    onUnmounted(() => {
      store.dispatch("show/resetShowSelection");
      store.dispatch("event/setState", { key: "event", value: {} });
      store.dispatch("event/setState", { key: "showHeader", value: false });
    });

    onMounted(async () => {
      store.dispatch("event/setState", { key: "showHeader", value: true });
      const slug = proxy.$route.params.slug;
      await store.dispatch("event/findEvent", slug);
      await store.dispatch("show/fetchBySlug", slug);
    });

    useMeta(
      computed(() => ({
        title: state.event?.title ?? "",
        description: state.event?.description ?? "",
      }))
    );

    const onGetTickets = () => {
      if (state.selectedShow.show.tickets) {
        router.push({
          name: "standingSelection",
          params: {
            showSlug: state.selectedShow.show.slug,
          },
        });
      } else {
        router.push({
          name: "seatSelection",
          params: {
            showSlug: state.selectedShow.show.slug,
          },
        });
      }
    };

    const handleShowSelection = (e) => {
      const show = state.showTimes.find((a) => a.id === e.target.value);
      state.selectedShow.show = show;
    };

    return {
      ...toRefs(state),
      onGetTickets,
      dateTimeFormat,
      handleShowSelection,
    };
  },
};
</script>
<style lang="scss">
.show-selector {
  position: relative;
  select {
    appearance: none;
    border: 1px solid;
    box-shadow: none;
    flex: 1;
    padding: 0 1em;
    color: #fff;
    background-color: transparent;
    background-image: none;
    cursor: pointer;
  }
  select::-ms-expand {
    display: none;
  }
  .select {
    position: relative;
    display: flex;
    height: 3em;
    border-radius: 0.25em;
    overflow: hidden;
  }
  .select::after {
    content: "\25BC";
    position: absolute;
    top: 0;
    right: 0;
    padding: 1em;
    transition: 0.25s all ease;
    pointer-events: none;
  }
  .select:hover::after {
    color: #707070;
  }
}
.restriction {
  ul {
    list-style: decimal-leading-zero;
    margin-left: 40px;
    li {
      margin-bottom: 5px;
    }
  }
}
</style>
